import React from 'react';
import { Banner } from 'prospect-path-base';
import PropTypes from 'prop-types';

const MessageBanner = ({banners, ...props}) => (
    <div {...props}>
        {banners.map(banner => (
            <div style={{ padding: '80px 83px 20px 83px' }}>
                <Banner
                    key={banner.title}
                    reference={banner.reference}
                    type={banner.type}
                    title={banner.title}
                    children={banner.body}
                    closeable={banner.closeable}
                >
                </Banner>
            </div>
        ))}
    </div>
)

MessageBanner.defaultProps = {
    banners: [],
}

MessageBanner.propTypes = {
    banners: PropTypes.array,
}

export default MessageBanner;
